import type { HoComponents } from '@pos/api-client';
import { crudApi, type CrudRecord } from '@pos/admin-ui';
import { hoApi } from '../api';

type Dto = HoComponents['schemas'];
export type PaymentProfile = Dto['PaymentProfileDto'];
export type PaymentProfileInput = Dto['PaymentProfileInput'];
export type PaymentProfileAssignmentInput = Dto['PaymentProfileAssignmentInput'];
export type PaymentProfileAccountInput = Dto['PaymentProfileAccountInput'];

/** POS setup's permissions: payments serve every channel (ADR 0074). The server checks them again. */
export const PAYMENTS_READ = 'ho.config.payment_methods.read';
export const PAYMENTS_MANAGE = 'ho.config.payment_methods.manage';

export const profilesKey = ['ho', 'payment', 'profiles'] as const;
export const salesChannelsKey = ['ho', 'config', 'sales-channels', 'all'] as const;

/** Sales channels, for choosing where a profile is used. */
export const salesChannelsApi = crudApi<CrudRecord & { code: string; name: string; channelType: string }, never>(hoApi, '/api/v1/menu/config/sales-channels');

async function unwrap<T>(call: Promise<{ data?: T; error?: unknown; response: Response }>): Promise<T> {
  const { data, error, response } = await call;
  if (data === undefined) {
    if (response.ok) return undefined as T;
    throw error ?? { status: response.status };
  }
  return data;
}

export const listProfiles = () => unwrap(hoApi.GET('/api/v1/integration/payment/profiles'));

export const saveProfile = (id: string | undefined, body: PaymentProfileInput) =>
  id
    ? unwrap(hoApi.PUT('/api/v1/integration/payment/profiles/{id}', { params: { path: { id } }, body }))
    : unwrap(hoApi.POST('/api/v1/integration/payment/profiles', { body }));

export const deleteProfile = (id: string) => unwrap(hoApi.DELETE('/api/v1/integration/payment/profiles/{id}', { params: { path: { id } } }));

export const setProfileAccounts = (id: string, accounts: PaymentProfileAccountInput[]) =>
  unwrap(hoApi.PUT('/api/v1/integration/payment/profiles/{id}/accounts', { params: { path: { id } }, body: { accounts } }));

export const assignProfile = (id: string, body: PaymentProfileAssignmentInput) =>
  unwrap(hoApi.POST('/api/v1/integration/payment/profiles/{id}/assignments', { params: { path: { id } }, body }));

export const unassignProfile = (id: string, assignmentId: string) =>
  unwrap(hoApi.DELETE('/api/v1/integration/payment/profiles/{id}/assignments/{assignmentId}', { params: { path: { id, assignmentId } } }));
